<template>
  <div class="text-center">
    <div class="sm:hidden px-2 py-1">
      <select
        id="location"
        class="form-select block w-full pl-3 pr-10 py-2 text-base leading-6 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
      >
        <option selected>Ordenar</option>
        <option>Por Fecha</option>
        <option>Por Precio</option>
      </select>
    </div>
    <div class="sm:hidden px-2 py-1">
      <select aria-label="Selected tab" class="form-select block w-full" v-model="chosenCategory" @change="onCategorySelected()">
        <option value="all" selected>Todos</option>
        <option value="Gasfitero">Gasfitero</option>
        <option value="Electricista">Electricista</option>
        <option value="Carpintero">Carpintero</option>
        <option value="Cerrajero">Cerrajero</option>
      </select>
    </div>
    <div class="hidden sm:block">
      <nav class="flex justify-center">
        <div>
          <select
            id="location"
            class="form-select block w-full pl-3 pr-10 py-2 text-base leading-6 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
          >
            <option selected>Ordenar</option>
            <option>Por Fecha</option>
            <option>Por Precio</option>
          </select>
        </div>
        <a
          @click="chosenCategory='all';onCategorySelected();"
          :class="chosenCategory=='all'?'text-primary-700 bg-primary-200 focus:text-primary-800 focus:bg-primary-200':'text-gray-500 hover:text-gray-700 focus:text-primary-600 focus:bg-primary-50'"
          class="cursor-pointer ml-4 px-3 py-2 font-medium text-sm leading-5 rounded-md focus:outline-none"
        >Todos</a>
        <a
          @click="chosenCategory='Gasfitero';onCategorySelected();"
          :class="chosenCategory=='Gasfitero'?'text-primary-700 bg-primary-200 focus:text-primary-800 focus:bg-primary-200':'text-gray-500 hover:text-gray-700 focus:text-primary-600 focus:bg-primary-50'"
          class="cursor-pointer ml-4 px-3 py-2 font-medium text-sm leading-5 rounded-md  focus:outline-none"
        >Gasfitero</a>
        <a
          @click="chosenCategory='Electricista';onCategorySelected();"
          :class="chosenCategory=='Electricista'?'text-primary-700 bg-primary-200 focus:text-primary-800 focus:bg-primary-200':'text-gray-500 hover:text-gray-700 focus:text-primary-600 focus:bg-primary-50'"
          class="cursor-pointer ml-4 px-3 py-2 font-medium text-sm leading-5 rounded-md  focus:outline-none"
          aria-current="page"
        >Electricista</a>
        <a
          @click="chosenCategory='Carpintero';onCategorySelected();"
          :class="chosenCategory=='Carpintero'?'text-primary-700 bg-primary-200 focus:text-primary-800 focus:bg-primary-200':'text-gray-500 hover:text-gray-700 focus:text-primary-600 focus:bg-primary-50'"
          class="cursor-pointer ml-4 px-3 py-2 font-medium text-sm leading-5 rounded-md  focus:outline-none"
        >Carpintero</a>
        <a
          @click="chosenCategory='Cerrajero';onCategorySelected();"
          :class="chosenCategory=='Cerrajero'?'text-primary-700 bg-primary-200 focus:text-primary-800 focus:bg-primary-200':'text-gray-500 hover:text-gray-700 focus:text-primary-600 focus:bg-primary-50'"
          class="cursor-pointer ml-4 px-3 py-2 font-medium text-sm leading-5 rounded-md  focus:outline-none"
        >Cerrajero</a>
      </nav>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      chosenCategory: 'all'
    }
  },
  methods: {
    onCategorySelected() {
      this.$emit("onCategorySelected", this.chosenCategory);
    }
  }
}
</script>